import { ExternalUnmatchedTransaction } from '../model/single-transaction/external-unmatched-transaction'
import {
  FXMappingModel,
  FXSpot,
} from '../model/single-transaction/fx-spot-trade/fx-spot.model'

/**
 * Function for Create FxForward mapping
 */
export function generateFxForwardCreateMapping(
  reconDate: string,
): FXMappingModel[] {
  return [
    {
      id: 'account',
      validityStatus: 'valid',
      type: 'string',
      isEditable: false,
      field: 'Account',
      value: '',
      errorMessage: '',
    },
    {
      id: 'entryDate',
      validityStatus: 'valid',
      type: 'date',
      isEditable: true,
      field: 'Entry Date',
      value: reconDate,
      errorMessage: '',
    },
    {
      id: 'settleDate',
      validityStatus: 'valid',
      type: 'date',
      isEditable: true,
      field: 'Settle Date',
      value: reconDate,
      errorMessage: '',
    },
    {
      id: 'fromSecurityId',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'From Security',
      value: '',
      errorMessage: '',
    },
    {
      id: 'toSecurityId',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'To Security',
      value: '',
      errorMessage: '',
    },
    {
      id: 'fromUnits',
      validityStatus: 'valid',
      type: 'number',
      isEditable: true,
      field: 'From Units',
      value: '',
      errorMessage: '',
    },
    {
      id: 'toUnits',
      validityStatus: 'valid',
      type: 'number',
      isEditable: true,
      field: 'To Units',
      value: '',
      errorMessage: '',
    },
    {
      id: 'counterParty',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'Counter Party',
      value: 'Unknown',
      errorMessage: '',
    },
  ]
}

/**
 * Function for Edit FxForward mapping
 */
export function generateFxForwardEditMapping(
  fxTransaction: FXSpot,
  fromSecurityCusip: string,
  toSecurityCusip: string,
): FXMappingModel[] {
  return [
    {
      id: 'account',
      validityStatus: 'valid',
      type: 'string',
      isEditable: false,
      field: 'Account',
      value: fxTransaction.accountId.toString(),
      errorMessage: '',
    },
    {
      id: 'entryDate',
      validityStatus: 'valid',
      type: 'date',
      isEditable: true,
      field: 'Entry Date',
      value: fxTransaction.entryDate,
      errorMessage: '',
    },
    {
      id: 'settleDate',
      validityStatus: 'valid',
      type: 'date',
      isEditable: true,
      field: 'Settle Date',
      value: fxTransaction.settleDate,
      errorMessage: '',
    },
    {
      id: 'fromSecurityId',
      validityStatus: 'valid',
      type: 'string',
      isEditable: false,
      field: 'From Security',
      value: fromSecurityCusip,
      errorMessage: '',
    },
    {
      id: 'toSecurityId',
      validityStatus: 'valid',
      type: 'string',
      isEditable: false,
      field: 'To Security',
      value: toSecurityCusip,
      errorMessage: '',
    },
    {
      id: 'fromUnits',
      validityStatus: 'valid',
      type: 'number',
      isEditable: true,
      field: 'From Units',
      value: Number(fxTransaction.fromUnits).toString(),
      errorMessage: '',
    },
    {
      id: 'toUnits',
      validityStatus: 'valid',
      type: 'number',
      isEditable: true,
      field: 'To Units',
      value: Number(fxTransaction.toUnits).toString(),
      errorMessage: '',
    },
    {
      id: 'counterParty',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'Counter Party',
      value: fxTransaction.counterParty?.name ?? 'Unknown',
      errorMessage: '',
    },
  ]
}

/**
 * Function for External FxForward mapping
 */
export function generateFxForwardExternalMapping(
  fxTransaction: ExternalUnmatchedTransaction,
  toSecurityCusip: string,
  fromSecurityCusip: string,
  isAggregate: boolean,
): FXMappingModel[] {
  return [
    {
      id: 'account',
      validityStatus: 'valid',
      type: 'string',
      isEditable: isAggregate,
      field: 'Account',
      value: fxTransaction.accountId.toString(),
      errorMessage: '',
    },
    {
      id: 'entryDate',
      validityStatus: 'valid',
      type: 'date',
      isEditable: true,
      field: 'Entry Date',
      value: fxTransaction.entryDate,
      errorMessage: '',
    },
    {
      id: 'settleDate',
      validityStatus: 'valid',
      type: 'date',
      isEditable: true,
      field: 'Settle Date',
      value: fxTransaction.settleDate,
      errorMessage: '',
    },
    {
      id: 'fromSecurityId',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'From Security',
      value: fromSecurityCusip,
      errorMessage: '',
    },
    {
      id: 'toSecurityId',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'To Security',
      value: toSecurityCusip,
      errorMessage: '',
    },
    {
      id: 'fromUnits',
      validityStatus: 'valid',
      type: 'number',
      isEditable: true,
      field: 'From Units',
      value: fxTransaction.fromUnits
        ? Number(fxTransaction.fromUnits).toString()
        : '',
      errorMessage: '',
    },
    {
      id: 'toUnits',
      validityStatus: 'valid',
      type: 'number',
      isEditable: true,
      field: 'To Units',
      value: fxTransaction.units ? Number(fxTransaction.units).toString() : '',
      errorMessage: '',
    },
    {
      id: 'counterParty',
      validityStatus: 'valid',
      type: 'string',
      isEditable: true,
      field: 'Counter Party',
      value: fxTransaction.clearwaterCounterParty?.name ?? 'Unknown',
      errorMessage: '',
    },
  ]
}
